import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { ITextMessage } from "../../../../models/pushMessage.model";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  record: ITextMessage|undefined;
}

const ShowMessageModal: FC<IProps> = ({
  visible,
  setVisible,
  record,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('message.smsSend.title2')}
      visible={visible}
      onCancel={() => setVisible(false)}
      width={600}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <div dangerouslySetInnerHTML={{ __html: record?.content || '' }} />
    </Modal>
  );
}

export default ShowMessageModal;
